import PropTypes from 'prop-types'
import classNames from 'classnames'

import AccoladeBadges from './AccoladeBadges'
import AvatarPlaceholder from '../../assets/images/mock/default-profile-icon.png'

import classes from './CoachProfileCard.module.scss'

const CoachProfileCard = ({ coach }) => {
  const fullName = `${coach.first_name || ''} ${coach.last_name || ''}`.trim()
  const organizationNames = (coach.organizations || []).map(organization => organization.name).join(', ')
  const coverUrl = coach.header_photo?.file_url

  return (
    <section className={classes.card}>
      <div className={classes.cover} style={coverUrl ? { backgroundImage: `url(${coverUrl})` } : undefined} />
      <div className='d-flex flex-column align-items-center text-center px-3 pb-4'>
        <img src={coach.avatar?.file_url || AvatarPlaceholder} alt='' className={classes.avatar} />
        <h2 className={classNames('mb-0 mt-2', classes.name)}>{fullName}</h2>
        {coach.headline && <p className={classNames('mb-0 mt-1', classes.headline)}>{coach.headline}</p>}
        {organizationNames && <p className={classNames('mb-0 mt-1', classes.organizations)}>{organizationNames}</p>}
        <div className='mt-3 w-100'>
          <AccoladeBadges userAccolades={coach.user_accolades} />
        </div>
      </div>
    </section>
  )
}

CoachProfileCard.propTypes = {
  coach: PropTypes.shape({
    id: PropTypes.number.isRequired,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    headline: PropTypes.string,
    avatar: PropTypes.shape({ file_url: PropTypes.string }),
    header_photo: PropTypes.shape({ file_url: PropTypes.string }),
    organizations: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number, name: PropTypes.string })),
    user_accolades: PropTypes.array,
  }).isRequired,
}

export default CoachProfileCard
